import React from "react"
import { PasswordInput } from "@mantine/core"
import { IconEye, IconEyeOff } from "@tabler/icons-react"
import { ForgeRockCallbackProps } from "@models/forgeRock.model"

export const PasswordCallbackInput: React.FC<ForgeRockCallbackProps> = ({
	callback,
	index,
	currentStepNumber,
	callbackValues,
	updateCallbackValue,
	isLoading,
	hasError,
	loginFormComponentData
}) => {
	const prompt = callback.getPrompt?.() || ""
	const existingValue = (callbackValues[index] ??
		callback.getInputValue?.() ??
		"") as string
	const shouldDisableInputs = isLoading

	return (
		<PasswordInput
			key={`password-${index}-step-${currentStepNumber}`}
			placeholder={loginFormComponentData?.password || prompt}
			value={existingValue}
			onChange={(event) =>
				updateCallbackValue(index, event.currentTarget.value)
			}
			disabled={shouldDisableInputs}
			variant="login"
			aria-label={loginFormComponentData?.password || prompt}
			error={hasError}
			visibilityToggleIcon={({ reveal }) =>
				reveal ? (
					<IconEye
						size={20}
						color="var(--mantine-color-royal-21)"
						data-qa="ushome.button.show.password"
					/>
				) : (
					<IconEyeOff
						size={20}
						color="var(--mantine-color-royal-21)"
						data-qa="ushome.button.hide.password"
					/>
				)
			}
			data-qa="ushome.input.password"
		/>
	)
}
